export const STATUS_OPTIONS = [
  "Enquiry",
  "Follow Up",
  "Not Interested",
  "On-board",
  "Irrelevant",
  "Contacted",
  "Options Provided",
  "In Progress",
  "Completed",
  "Not converted",
  "No Response",
  "Meeting Fixed",
  "Meeting Done",
  "Visit",
  "Payment Received",
];